export const FoodDatas = [
    "산", "회", "갈비", "곰탕", "국밥", "국수", "기업", "냉면", "병원", "분식",
    "뷔페", "순대", "술집", "시장", "양식", "여행", "오리", "일식", "장어", "조개",
    "중식", "지명", "철강", "추어", "치킨", "카페", "피자", "한식", "감자탕", "닭요리",
    "떡볶이", "부동산", "삼겹살", "설렁탕", "양꼬치", "오뎅바", "와인바", "유적지", "음식점",
    "일식집", "자동차", "정육점", "제조업", "주유소", "참치회", "칼국수", "한정식", "해장국",
    "햄버거", "게,대게", "굴,전복", "초밥,롤", "가구판매", "도보여행", "먹자골목", "문화유적",
    "슈퍼마켓", "식품판매", "이탈리안", "중국요리", "테마거리", "테마카페", "피자마루", "한식뷔페",
    "가정,생활", "곱창,막창", "관광,명소", "교통,수송", "육류,고기", "의료,건강", "족발,보쌈",
    "주유,가스", "찌개,전골", "해물,생선", "S-oil주유소", "디저트카페", "수산물판매", "아시아음식",
    "일본식주점", "해산물뷔페", "돈까스,우동", "서비스,산업", "스테이크,립", "마피아떡볶이",
    "실내포장마차", "매운탕,해물탕", "상가,아케이드", "해수욕장,해변", "호프,요리주점",
    "불고기,두루치기", "동대문엽기떡볶이", "계곡", "공원", "광장", "놀숲", "다방", "도넛", "복권",
    "복어", "서원", "숙박", "식껍", "취미", "펜션", "만화방", "백화점", "삼계탕", "수제비", "주차장",
    "축산업", "캔모아", "토스트", "휴게소", "떡,한과", "탑,비석", "GS칼텍스", "고반식당", "공간대여",
    "교통시설", "구내식당", "기사식당", "대형마트", "대형슈퍼", "롯데리아", "만화카페", "반찬가게",
    "보배반점", "삼산회관", "샌드위치", "생활맥주", "샤브샤브", "여가시설", "육회본가", "인쌩맥주",
    "전문대행", "철판요리", "태국음식", "틈새라면", "푸드코트", "퓨전요리", "홈플러스", "농장,목장",
    "단체,협회", "게임방,PC방", "동남아음식", "두부전문점", "복합쇼핑몰", "순살만공격", "아이스크림",
    "원조부안집", "이삭토스트", "족발신선생", "파리바게뜨", "패스트푸드", "하나로마트", "하남돼지집",
    "수도권1호선", "지하철,전철", "고봉민김밥인", "도시근린공원", "만족오향족발", "생과일전문점",
    "스텔라떡볶이", "신세계백화점", "멕시칸,브라질", "사철탕,영양탕", "사회,공공기관", "제과,베이커리",
    "걸작떡볶이치킨", "고속도로휴게소", "역전할머니맥주", "큰맘할매순대국", "패밀리레스토랑", "간식"
];
